export default __webpack_public_path__ + "assets/images/615467cb57761e0d880347898ddedc64.jpeg";